import {FeatureGroups} from './data/FeatureData'

let cos = Math.cos
let sin = Math.sin
let sqrt = Math.sqrt
let floor = Math.floor

export const TAU = Math.PI *2
export const PI = Math.PI

export class SColor {
  constructor(r,g,b,a){
    Object.assign(this,{r,g,b,a})
  }
  
  get hexInt() {
    let t = this
    if (t.r > 255 || t.g > 255 || t.b > 255){return 0}
    return ((t.r << 16) | (t.g << 8) | t.b)
  }
  
  get hex(){
    return ("000000" + this.hexInt.toString(16)).slice(-6);
  }
}

export const rgbToHex = function (r, g, b) {
  if (r > 255 || g > 255 || b > 255){return 0}
  return ((r << 16) | (g << 8) | b).toString(16);
}

export const getColorAverage = function(img, imgWidth, imgHeight, points){
  let mul = 1/points.length
  let ctotals = {r:0, g:0, b:0}
  
  for (let p of points){
    let c = getColor(img, imgWidth, imgHeight, p.x, p.y)
    ctotals.r+= c.r*mul;
    ctotals.g+= c.g*mul;
    ctotals.b+= c.b*mul;
  }

  return new SColor(floor(ctotals.r),floor(ctotals.g),floor(ctotals.b),1)
}


let pixcanvas = document.createElement('canvas')
export const getColor = function(img, imgWidth, imgHeight, x, y){
  let canvas = pixcanvas
  canvas.width = imgWidth
  canvas.height = imgHeight
  var ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(img,0,0);
  var p = ctx.getImageData(x, y, 1, 1).data;

  let r=p[0]
  let g=p[1]
  let b=p[2]
  let a=p[3]
  
  return new SColor(r,g,b,a)
}






function rotate(cx, cy, x, y, angle) {
  let radians = (PI / 180) * angle
  let cosR = cos(radians)
  let sinR = sin(radians)
  let nx = (cosR * (x - cx)) + (sinR * (y - cy)) + cx
  let ny = (cosR * (y - cy)) - (sinR * (x - cx)) + cy
  return [nx, ny];
}


//MATH
export const rotatePoint2D = function(p, c, radian){
  let r = radian
  let cosR = cos(radian)
  let sinR = sin(radian)
    
  let x = (cosR * (p.x - c.x)) + (sinR * (p.y - c.y)) + c.x
  let y = (cosR * (p.y - c.y)) - (sinR * (p.x - c.x)) + c.y

  return {x,y}
}

export const getLerp = function (x, xx,  t){
  return  x + t * (x - xx)
}
export const  getLerp2D = function (x1, y1, x2, y2, t){
  let x = x1 + t * (x2 - x1)
  let y = y1 + t * (y2 - y1)
  return {x,y}
}

export const  getLerpP = function (p1, p2, t){
  return getLerp2D(p1.x, p1.y, p2.x, p2.y, t)
}

export const lengthP = function( p ) {
  return sqrt( (p.x * p.x) + (p.y * p.y) );
}

export const distanceP = function( p1, p2 ) {
  return getDistance2D(p1.x, p1.y, p2.x, p2.y)
}



export const getDistance2D = function( x1, y1, x2, y2 ) {
  let   xs = x2 - x1
  let   ys = y2 - y1
  return sqrt( (xs * xs) + (ys * ys) );
}

//CANVAS DRAW UTILS

/*
eg: var polygonPoints = polygonPoints = [{x:10,y:100},{x:20,y:75},{x:50,y:100}];
fillPolygon(context, polygonPoints, 'rgba(255,0,0,0.7)','rgba(0,0,0,0.7)', 2, true);
 */
let fillPolygonCanvas = document.createElement('canvas');
export const fillPolygon = function (_canvas, origin, scale, pointsArray, fillColor, strokeColor, linewidth, close) {
  let _ctx = _canvas.getContext('2d');
  let can2 = fillPolygonCanvas;
  can2.width = _canvas.width;
  can2.height = _canvas.height;
  let ctx = can2.getContext('2d');
  ctx.clearRect(0, 0, can2.width, can2.height);

  ctx.strokeStyle = strokeColor;
  ctx.fillStyle = fillColor;
  ctx.lineWidth = linewidth;
  
  

  ctx.globalCompositeOperation = 'destination-atop';
  
  let s = scale
  
  if (pointsArray.length <= 0) return;
  ctx.moveTo((pointsArray[0].x * s) + origin.x, (pointsArray[0].y * s) + origin.y);
  for (let i = 0; i < pointsArray.length; i++) {
    ctx.lineTo((pointsArray[i].x * s) + origin.x, (pointsArray[i].y * s) + origin.y);
  }
  if (close){
    ctx.lineTo((pointsArray[0].x * s) + origin.x, (pointsArray[0].y * s) + + origin.y);
  }
  
  
  if (strokeColor !== null && strokeColor !== undefined){
    ctx.strokeStyle = strokeColor;
    ctx.stroke();
  }

  if (fillColor !== null && fillColor !== undefined) {
    ctx.fillStyle = fillColor;
    ctx.fill();
  }

  _ctx.drawImage(can2, 0, 0);
}

//LAYOUT UTILS-------------------------------------------------------------------------//

/*eslint-disable */
//TODO convert to output component
export const syntaxHighlightJSON = function(json) {
  json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
    var cls = 'number';
    if (/^"/.test(match)) {
      if (/:$/.test(match)) {
        cls = 'key';
      } else {
        cls = 'string';
      }
    } else if (/true|false/.test(match)) {
      cls = 'boolean';
    } else if (/null/.test(match)) {
      cls = 'null';
    }
    return '<span class="' + cls + '">' + match + '</span>';
  });
}
/*eslint-enable */


//TODO convert to output vue component
export const outputFaceFeaturesGroupedVertical = function(faceInfo){
  //vertical layout for column-selection - can  drop into spreadsheet for compare

  let info = faceInfo
  var featureText1 = "<div class='feat_col'>"
  var featureText2 = "<div class='feat_col'>"
  var featureText3 = "<div class='feat_col'>"
  var featureText4 = "<div class='feat_col'>"
  var f = info.features
  let g = FeatureGroups
  for (let title in g){
    //section label
    featureText1 += "<div class='feature_t'>"+title + "</div>"
    featureText2 += "<div class='feature_t'>-</div>"
    featureText3 += "<div class='feature_t'>-</div>"
    featureText4 += "<div class='feature_t'>-</div>"

    let o = g[title]
    for (let key of o){
      let hasValue = (f[key] !== undefined)
      let value = (hasValue) ? f[key].value : 'undefined'
      let confidence = (hasValue) ? f[key].confidence : '0'

      if(!hasValue){console.warn("! missing expected feature attribute:", key)}

      let ok = (parseFloat(confidence) > 0.05)
      let c = (ok) ? "feature_v" : "feature_vq"
      let swatch = (hasValue && key.indexOf("color")> -1) ? value : 'ffffff';
      featureText1 += "<div class='feature_k'>"+key + "</div>"
      featureText2 += "<div class='"+ c +"'> "+value + "</div>"
      featureText3 += "<div class='feature_c'> "+ confidence + "</div>"
      featureText4 += "<div class='feature_swatch' style='background-color: #"+ swatch +";'></div>"
    }
  }

  featureText1 += "</div>"
  featureText2 += "</div>"
  featureText3 += "</div>"
  var featureText = featureText1 + featureText2 +featureText3 + featureText4

  //$('.output_features_grouped').html(featureText);
  return featureText;
}


//TODO convert to output vue component
function outputFaceFeatures(faceInfo){
  let info = faceInfo
  var featureText = ""
  var o = info.features
  for (let key in o){
    let ok = (parseFloat(o[key].confidence) > 0.05)
    let c = (ok) ? "feature_v" : "feature_vq"
    featureText+= "<div class='feature_k'>"+key + "</div>" + "<div class='"+ c +"'> "+o[key].value + "</div>" + "<div class='feature_c'> "+o[key].confidence + "</div> <br>"
  }
 // $('.output_features').html(featureText);
  return featureText;
}

  

  